import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'active', // active class for non-exact links.
  linkExactActiveClass: 'active', // active class for *exact* links.

  getRouteByName: (routeArray, name) => {
    const matches = routeArray.map((item) => {
      if (item.children) {
        return item.children.find(child => child.name === name);
      }
      return false;
    });

    return matches.find(item => (item !== undefined && item !== false));
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js